module.exports = __webpack_public_path__ + "static/media/voix4.a0ce605b.ogg";